import React from 'react'
import classes from "../css/TopLines.module.css";

const TopLines = () => {
  return (
    <div className={classes.topLines}>
    <div className={classes.line1}></div>
    <div className={classes.line2}></div>
  </div>
  )
}

export default TopLines